export const DATA_LOADED = 'DATA_LOADED';
export const DATA_LOADING = 'DATA_LOADING';
export const PAGE_NAVIGATED = 'PAGE_NAVIGATED';
export const PAGE_REFRESHED = 'PAGE_REFRESHED';